import { MdInfoOutline } from 'react-icons/md';
import { Selection, Dropdown, DropdownItem, DropdownMenu, DropdownTrigger, Divider } from '@ds';
import { OMS_SLOT_OPTION_DROPDOWN_LIST } from '@lp/features/Scheduler/SchedulerOMS/constants';

type DualSlotDropdownProps = {
  optionName: string;
  selectedSlotKeys: string[];
  disabledSlotKeys: string[];
  disallowEmptySelection: boolean;
  onSlotsSelectionChange: (keys: Selection) => void;
  infoMessage?: string;
};

export const DualSlotDropdown = ({
  optionName,
  selectedSlotKeys,
  disabledSlotKeys,
  disallowEmptySelection,
  onSlotsSelectionChange,
  infoMessage,
}: DualSlotDropdownProps) => {
  return (
    <Dropdown placement="right" closeOnSelect={false}>
      <DropdownTrigger>
        <div>{optionName}</div>
      </DropdownTrigger>
      <DropdownMenu
        aria-label="Select Shift Slot"
        disallowEmptySelection={disallowEmptySelection}
        selectionMode="multiple"
        selectedKeys={selectedSlotKeys}
        disabledKeys={disabledSlotKeys}
        onSelectionChange={onSlotsSelectionChange}
        bottomContent={
          infoMessage ? (
            <>
              <Divider orientation="horizontal" />
              <div className="flex items-center gap-1.5 px-2 pt-1 max-w-57.5 text-s-r text-base-20">
                <MdInfoOutline size={14} className="shrink-0" />
                <span>{infoMessage}</span>
              </div>
            </>
          ) : undefined
        }
      >
        {OMS_SLOT_OPTION_DROPDOWN_LIST.map((slot) => (
          <DropdownItem key={slot.slotIndex} textValue={slot.label}>
            <div className="flex gap-2 text-m-r text-base-5">
              <span>{slot.label}</span>
              <span className="text-base-25">{slot.timeRange}</span>
            </div>
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  );
};
